"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconReports = function IconReports(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconReports', className),
    style: style,
    viewBox: "0 0 20 20"
  }, _react.default.createElement("g", {
    id: "final",
    stroke: "currentColor",
    strokeWidth: "0",
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", {
    id: "icons",
    transform: "translate(-155.000000, -58.000000)"
  }, _react.default.createElement("g", {
    id: "Reports",
    transform: "translate(153.000000, 56.000000)"
  }, _react.default.createElement("g", {
    id: "Reporting"
  }, _react.default.createElement("rect", {
    id: "Rectangle-2",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), _react.default.createElement("g", {
    id: "Group-2",
    transform: "translate(2.375000, 2.833333)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, _react.default.createElement("path", {
    d: "M15.0116667,-0.65 L4.23833333,-0.65 C1.79171189,-0.65 -0.191666667,1.33337856 -0.191666667,3.78 L-0.191666667,14.5533333 C-0.191666667,16.9999548 1.79171189,18.9833333 4.23833333,18.9833333 L15.0116667,18.9833333 C17.4582881,18.9833333 19.4416667,16.9999548 19.4416667,14.5533333 L19.4416667,3.78 C19.4416667,1.33337856 17.4582881,-0.65 15.0116667,-0.65 Z M4.23833333,0.65 L15.0116667,0.65 C16.7403179,0.65 18.1416667,2.05134873 18.1416667,3.78 L18.1416667,14.5533333 C18.1416667,16.2819846 16.7403179,17.6833333 15.0116667,17.6833333 L4.23833333,17.6833333 C2.50968207,17.6833333 1.10833333,16.2819846 1.10833333,14.5533333 L1.10833333,3.78 C1.10833333,2.05134873 2.50968207,0.65 4.23833333,0.65 Z",
    id: "Rectangle-11"
  }), _react.default.createElement("path", {
    d: "M9.625,8.51666667 C9.95135008,8.51666667 10.2215265,8.75717486 10.2679523,9.07061443 L10.275,9.16666667 L10.275,15.125 C10.275,15.4839851 9.98398509,15.775 9.625,15.775 C9.29864992,15.775 9.02847354,15.5344918 8.98204767,15.2210522 L8.975,15.125 L8.975,9.16666667 C8.975,8.80768158 9.26601491,8.51666667 9.625,8.51666667 Z",
    id: "Line-2"
  }), _react.default.createElement("path", {
    d: "M14.2083333,5.76666667 C14.5346834,5.76666667 14.8048598,6.00717486 14.8512857,6.32061443 L14.8583333,6.41666667 L14.8583333,15.125 C14.8583333,15.4839851 14.5673184,15.775 14.2083333,15.775 C13.8819833,15.775 13.6118069,15.5344918 13.565381,15.2210522 L13.5583333,15.125 L13.5583333,6.41666667 C13.5583333,6.05768158 13.8493482,5.76666667 14.2083333,5.76666667 Z",
    id: "Line-2-Copy-2"
  }), _react.default.createElement("path", {
    d: "M5.04166667,3.93333333 C5.36801675,3.93333333 5.63819313,4.17384153 5.684619,4.4872811 L5.69166667,4.58333333 L5.69166667,15.125 C5.69166667,15.4839851 5.40065175,15.775 5.04166667,15.775 C4.71531659,15.775 4.44514021,15.5344918 4.39871434,15.2210522 L4.39166667,15.125 L4.39166667,4.58333333 C4.39166667,4.22434825 4.68268158,3.93333333 5.04166667,3.93333333 Z",
    id: "Line-2-Copy"
  })))))));
};

var _default = IconReports;
exports.default = _default;